<template>
  <div class="cliente-inmobiliario-grid">
    <DxDataGrid
      v-bind="getDefaultGridProperties()"
      :data-source="gridSource"
      :show-borders="true"
      :column-auto-width="true"
      :row-alternation-enabled="true"
      :selected-row-keys="modelValue ? [modelValue] : []"
      @selection-changed="onSelectionChanged"
      @row-click="onRowClick"
    >
    
      <DxColumn data-field="Documento" :caption="$t('clienteInmobiliario.n_documento')"
        :customize-text="customizeTextUppercase" />
      <DxColumn data-field="NombreCompleto" :caption="$t('clienteInmobiliario.nombre')" />
      <DxColumn data-field="Email" :caption="$t('clienteInmobiliario.email')" />
      <DxColumn data-field="TelefonoMovil" :caption="$t('clienteInmobiliario.telMovil')" />
    </DxDataGrid>
  </div>
</template>

<script setup lang="ts">
import { useApi } from '@api/integration';
import type { DXLoadOptions } from '@api/api';
import { DxDataGrid, DxColumn } from 'devextreme-vue/data-grid';
import { onMounted, ref } from 'vue';
import type CustomStore from 'devextreme/data/custom_store';
import { customizeTextUppercase, getDefaultGridProperties } from '@helpers/grid-helper';

const api = useApi();
const gridSource = ref<CustomStore>();
const isInitializing = ref(true);

const props = defineProps<{
  modelValue?: string,
  idInmueble?: string,
  puedeCrearBorrador?: boolean,
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
  (e: 'cliente-selected', cliente: any): void
}>();

onMounted(async () => {
  await setDataSource();
});

const setDataSource = async () => {
  gridSource.value = api.apiStore({
    key: "Id",
    load: async (p) => {
      const q = p as DXLoadOptions;

      return await api.callStandardApi("getClientesEmpresaInmobiliariaForGrid", { showLoading: false }, q, props.idInmueble, props.puedeCrearBorrador)
    }
  });
}

const onSelectionChanged = (e: any) => {
  if ((isInitializing.value || !e.event) && e.selectedRowKeys.length === 0) {
    return;
  }

  if (e.selectedRowKeys.length > 0) {
    emit('cliente-selected', e.selectedRowsData[0]);
  } else {
    emit('cliente-selected', null);
  }
};

const onRowClick = (e: any) => {
  emit('cliente-selected', e.data);
};

</script>

<style lang="scss" scoped>


.cliente-inmobiliario-grid {
  height: 400px;
  width: 100%;
}

:deep(.dx-row.dx-data-row.dx-row-selected:hover) {
  background-color: red !important;
  cursor: pointer;
}

:deep(.dx-row.dx-data-row:hover) {
  background-color: var(--grid-alt-row-background) !important;
  cursor: pointer;
}
</style> 